import { NgModule } from '@angular/core';
import {
    CopierComponent,
    InfobarComponent,
    ShareDialogComponent,
    SharerComponent,
} from '@exl-ng/mulo-common';
import { ProfileActivationComponent } from './profile-activation.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        SharedModule,
        InfobarComponent,
        SharerComponent,
        ShareDialogComponent,
        CopierComponent,
        ProfileActivationComponent,
    ],
    exports: [ProfileActivationComponent],
})
export class ProfileActivationModule {}
